import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { ConfigElement } from "./ConfigElement";
import { ModalHeaderComponent } from "./ModalHeaderComponent";
import { SaveButtonComponent } from "./SaveButtonComponent";
import { filterActiveItems, generateClassAndText } from "@helpers/general";
import { useSnapshot } from "valtio";
import { store as defaultSettingStore } from "./DefaultModalContentWrapper/store";

type PropsType = {
    setIsOpen: (value: boolean) => void;
    isOpen: boolean;
    setIsConfigurationModalOpened: Function;
    setIsLoading: Function;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
};

export function DefaultSettingModal({
    setIsOpen,
    isOpen,
    setIsConfigurationModalOpened,
    setIsLoading,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: PropsType): JSX.Element {
    const { t } = useTranslation();

    const { defaultSetting } = useSnapshot(defaultSettingStore);

    const filteredTva = filterActiveItems(defaultSetting.tva?.data, "status");
    const filteredSaleMode = filterActiveItems(
        defaultSetting.saleMode?.data,
        "state"
    );
    const filteredLanguage = filterActiveItems(
        defaultSetting.language?.data,
        "status"
    );
    const filteredSaleSupport = filterActiveItems(
        defaultSetting.saleSupport?.data,
        "status"
    );
    const filteredPaymentMethod = filterActiveItems(
        defaultSetting.paymentMethod?.data,
        "isActive"
    );
    const filteredCurrency = filterActiveItems(
        defaultSetting.currency?.data,
        "status"
    );

    const [applicationsClass, applicationsText] = generateClassAndText(
        defaultSetting.applications?.data || [],
        "Application"
    );
    const [peripheralClass, peripheralText] = generateClassAndText(
        defaultSetting.peripheral?.data || [],
        "Péripheriques"
    );

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                isOpen={isOpen}
            >
                <ModalHeaderComponent setIsOpen={setIsOpen} isOpen={isOpen} />
                <ModalBody className="ml-2">
                    <ConfigElement
                        filteredTva={filteredTva}
                        filteredSaleMode={filteredSaleMode}
                        filteredLanguage={filteredLanguage}
                        filteredSaleSupport={filteredSaleSupport}
                        filteredPaymentMethod={filteredPaymentMethod}
                        filteredCurrency={filteredCurrency}
                        applicationsClass={applicationsClass}
                        applicationsText={applicationsText}
                        peripheralClass={peripheralClass}
                        peripheralText={peripheralText}
                    />
                </ModalBody>
                <ModalFooter>
                    <CustomSecondaryColorButton
                        className="w-20 kds_btn_validateTemplate"
                        rounded
                        variant="primary"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {t("Annuler")}
                    </CustomSecondaryColorButton>
                    <SaveButtonComponent
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                        setIsConfigurationModalOpened={
                            setIsConfigurationModalOpened
                        }
                        setIsLoading={setIsLoading}
                        filteredTva={filteredTva}
                        filteredSaleMode={filteredSaleMode}
                        filteredLanguage={filteredLanguage}
                        filteredSaleSupport={filteredSaleSupport}
                        filteredPaymentMethod={filteredPaymentMethod}
                        filteredCurrency={filteredCurrency}
                        applicationsClass={applicationsClass}
                        applicationsText={applicationsText}
                        peripheralClass={peripheralClass}
                        peripheralText={peripheralText}
                        setIsModalLoadingOpened={setIsModalLoadingOpened}
                        setModalLoadingData={setModalLoadingData}
                    />
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
